export const QA_NAME_OVERVIEW_VIEWING_ROW = 'rentalPortalOverviewViewingRow'

export const QA_NAME_OVERVIEW_VIEWING_ROW_APPLICANT =
  'rentalPortalOverviewViewingRowApplicant'

export const QA_NAME_OVERVIEW_VIEWING_ROW_UNIT =
  'rentalPortalOverviewViewingRowUnit'
